import { Form } from '@ant-design/compatible'

import ManageCampaignForm from './ManageCampaignForm'

export default Form.create({
  name: 'campaignForm',
})(ManageCampaignForm)
